import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { IUser } from '@interfaces/IUser';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  constructor(private _http: HttpClient) {}

  getEmailTokenValidity(token: string): Observable<{ detail: string }> {
    const url = `${environment.baseUrl}api/v1/users/verify-email/`;
    return this._http.patch<{ detail: string }>(url, { code: token });
  }

  verifyPhoneRequest(): Observable<{ detail: string }> {
    const url = `${environment.baseUrl}api/v1/users/verify-phone/`;
    return this._http.put<{ detail: string }>(url, {});
  }

  verifyPhone(code: string): Observable<{ detail: string }> {
    const url = `${environment.baseUrl}api/v1/users/verify-phone/`;
    return this._http.patch<{ detail: string }>(url, { code });
  }

  verifyEmailRequest(): Observable<{ detail: string }> {
    const url = `${environment.baseUrl}api/v1/users/verify-email/`;
    return this._http.put<{ detail: string }>(url, {});
  }

  editAvatar(newUserData: IUser): Observable<{ detail: string; url: string }> {
    const url = `${environment.baseUrl}api/v1/users/upload-avatar/`;
    return this._http.put<{ detail: string; url: string }>(url, newUserData);
  }

  changePassword(passwordData: {
    password: string;
    password_confirm: string;
    old_password: string;
  }): Observable<{ detail: string }> {
    const url = `${environment.baseUrl}api/v1/users/change-password/`;
    return this._http.put<{ detail: string }>(url, passwordData);
  }
}
